



















































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { IAddTVUser, IUnathorizedTV } from "@/@types/admin/add-tv-user";
import { auth } from "@/config/host.config";
import { deleteElement } from "@/api/delite/delite-element";

import p from "@/config/hotel";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import UnathorizedTvList from "../../tables/administration/unathorized/unathorized-tv-list.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    submit: SubmitResetButtonGroop,
    UnathorizedTvList,
  },
  mixins: [validationMixin],
  validations: {
    login: { required },
    room_number: { required },
  },
})
export default class AddTvAdminForm extends Vue {
  @Prop({ type: String, default: "tv" }) deviceType!: string;
  @Prop({ type: Boolean, default: true }) showLinkedBlock!: boolean;

  tvs: Array<IUnathorizedTV> = [];

  dontCloseForm = false;
  showUnathorizedTV = true;
  reservedUser: IUnathorizedTV | null = null;

  login = "";
  room_number = "";
  tv_name = "";
  comment = "";
  showLinked = false;
  linked_id = "";
  linked_name = "";
  linked_ip = "";
  linked_mac = "";
  linked_key = "";

  get labelPrefix(): string {
    return this.deviceType == "tablet"
      ? "Administration.tablet"
      : "Administration.tv";
  }

  get tvList(): Array<IUnathorizedTV> {
    if (this.deviceType == "tablet")
      return this.tvs.filter(
        (tv) =>
          String(tv.device_type) == "tablet" || String(tv.device_type) == "pad"
      );
    return this.tvs.filter(
      (tv) =>
        String(tv.device_type) != "tablet" && String(tv.device_type) != "pad"
    );
  }

  get registrationUrl(): string {
    return this.deviceType == "tablet"
      ? auth.registration_tablet
      : auth.registration_tv;
  }

  get user(): IAddTVUser {
    const data: IAddTVUser = {
      login: this.login,
      password: p,
      room_number: String(this.room_number),
      tv_name: this.tv_name,
      comment: this.comment,
    };
    if (this.showLinked) {
      data.linked = {
        id: this.linked_id,
        name: this.linked_name,
        ip: this.linked_ip,
        mac: this.linked_mac,
        key: this.linked_key,
      };
    }
    return data;
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  onSuccess(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("error.200")),
    });
  }

  addtv(id: string | null): void {
    if (this.reservedUser) {
      this.tvs.push(this.reservedUser);
      this.reservedUser = null;
    }
    if (!id) return;
    const i = this.tvs.findIndex((tv) => tv._id == id);
    if (i < 0) return;
    this.reservedUser = this.tvs[i];
    this.login = this.tvs[i].serialNumber;
    this.tvs.splice(i, 1);
  }

  deletedtv(id: string): void {
    deleteElement(id, auth.tvTicket)
      .then(() => {
        this.onSuccess();
        this.reservedUser = null;
        this.getTVTicket();
      })
      .catch(() => {
        this.onError();
      });
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      console.log("invalid");
      this.$v.$touch();
      return;
    }

    this.tvChange(this.user);
  }

  onReset(): void {
    if (this.reservedUser) this.tvs.push(this.reservedUser);
    this.login = "";
    this.room_number = "";
    this.tv_name = "";
    this.comment = "";
    this.showLinked = false;
    this.linked_id = "";
    this.linked_name = "";
    this.linked_ip = "";
    this.linked_mac = "";
    this.linked_key = "";
  }

  /**
   * TODO: Переделать обработку ошибок
   * * если status code ... выводить в alert "Пользователь с таким именем уже существует"
   */
  async tvChange(data: IAddTVUser): Promise<void> {
    try {
      const res = await this.$axios.post(this.registrationUrl, data);
      if (res.status === 200) {
        this.onSuccess();
        this.login = "";
        this.room_number = "";
        this.tv_name = "";
        this.comment = "";
        this.showLinked = false;
        this.linked_id = "";
        this.linked_name = "";
        this.linked_ip = "";
        this.linked_mac = "";
        this.linked_key = "";
        this.reservedUser = null;
        this.$emit("addUser", res.data);
        if (!this.dontCloseForm) this.$bvModal.hide("add-tv-modal");
      }
    } catch (e) {
      this.onError();
    }
  }

  async getTVTicket(): Promise<void> {
    try {
      const res = await this.$axios.get(auth.tvTicket);
      if (res.status === 200) this.tvs = res.data;
    } catch (e) {
      console.error(e);
    }
  }

  mounted(): void {
    this.getTVTicket();
  }

  destroyed(): void {
    this.login = "";
    this.room_number = "";
    this.tv_name = "";
    this.comment = "";
    this.showLinked = false;
    this.linked_id = "";
    this.linked_name = "";
    this.linked_ip = "";
    this.linked_mac = "";
    this.linked_key = "";
    this.reservedUser = null;
    this.tvs = [];
  }
}
